module.exports = __webpack_public_path__ + "51808e1363b9891d08d222b918f6b347.png";